function outerWidth(el) {
    var width = el.offsetWidth;
    var style = getComputedStyle(el);

    width += parseInt(style.marginLeft) + parseInt(style.marginRight);
    return width;
}
function outerHeight(el) {
    var height = el.offsetHeight;
    var style = getComputedStyle(el);

    height += parseInt(style.marginTop) + parseInt(style.marginBottom);
    return height;
}
function replaceAll(a, b, d) {
    "use strict";
    for (var c = a.indexOf(b); -1 < c;) {
        a = a.replace(b, d), c = a.indexOf(b);
    }
    return a;
}
function isElement(o) {
    return (
        typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
        o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string"
    );
}
function scrollToPage(id, title) {
    var targetSS = $('#' + id).offset().top - $('.navbar-header').height();

    $("html, body").stop().animate({scrollTop: targetSS + 'px'}, {duration: 1200, easing: "easeInOutExpo"});

    history.pushState(id, title, '/' + id);
}

function isValidEmail(a) {
    var b = !1;
    if ("undefined" != typeof a && (a = a.match(/(\w+)@(.+)\.(\w+)$/), null != a && (2 == a[3].length || 3 == a[3].length))) b = !0;
    return b;
}
